import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ModalComponent from '../../ui/Modal';

const mapStateToProps = state => ({
  user: state.Dashboard.user,
  errors: state.Global.errors
});

class ExportCalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      textCopied: false
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  copyToClipboard(copyText) {
    const el = document.createElement('textarea');
    el.value = copyText;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.setState({ textCopied: true });
  }

  onSubmit() {
    setTimeout(() => this.setState({ isSubmitting: true }), 240);
    this.props.onSubmit();
  }

  renderBody(exportLink) {
    return (
      <div>
        <span>Copy and paste the link below into other iCal applications or click the download link to download the .iCal file locally.</span>
        <div className="fieldgroup row mb-1">
          <div className="fake-input col-10 col-sm-11">{exportLink}</div>
          <button onClick={() => { this.copyToClipboard(exportLink) }} title="Copy iCal" className="col-1 btn copy-icon">
            <i className="far fa-copy fa-2x"></i>
          </button>
        </div>
        <div className="fieldgroup row mt-0">
          <a href={exportLink} title="Download iCal" className="download-link col-12 pt-0 pl-0" target="_blank">Download iCal File</a>
          {this.state.textCopied && <span className="copy-alert col-2 offset-6 p-0 text-right">iCal Copied!</span>}
        </div>
      </div>
    );
  }

  renderButtonRow(onClose) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-right">
          <button className='btn btn-primary' onClick={onClose}>Done</button>
        </div>
      </div>
    )
  }

  render() {
    let { onClose } = this.props;
    let { listingData } = this.props;
    let exportLink = `${location.origin}/api/ical/${listingData._id}`;

    return (<ModalComponent
      id="ExportCalModal"
      title="Export CollegeWeekends Calendar"
      body={this.renderBody(exportLink)}
      footer={this.renderButtonRow(onClose)}
      onClose={onClose} />
    );
  }
}

export default connect(mapStateToProps)(ExportCalComponent);
